import { render, staticRenderFns } from "./SocialMenu.vue?vue&type=template&id=5e9cddba&scoped=true&"
import script from "./SocialMenu.vue?vue&type=script&lang=js&"
export * from "./SocialMenu.vue?vue&type=script&lang=js&"
import style0 from "./SocialMenu.vue?vue&type=style&index=0&id=5e9cddba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9cddba",
  null
  
)

export default component.exports